import React from "react";
import { FaSyncAlt } from "react-icons/fa";
import "../../css/App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import themeLarge from "../ThemeLarge";

class StatCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      flipped: false,
      isMobile: window.innerWidth <= 768,
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth <= 768 });
  };

  toggleFlip = () => {
    this.setState((prev) => ({ flipped: !prev.flipped }));
  };

  renderFront = () => {
    return (
      <div className="card h-100 text-center p-3 card-face pokemon-front">
        <div className="front-image-frame">
          <img
            src="/images/machine_generated_ibtehaz.png"
            alt="Ibtehaz"
            className="img-fluid"
          />
        </div>

        {this.state.isMobile && (
          <>
            {/* Flavor Text */}
            <p className="flavor-text mt-3">
              "Once you learn the way broadly, you will see it in all things!"
            </p>
            <div
              className="rotate-icon position-absolute bottom-0 end-0 m-3"
              onClick={this.toggleFlip}
            >
              <FaSyncAlt />
            </div>
          </>
        )}
      </div>
    );
  };

  renderBack = () => {
    return (
      <div className="card h-100 p-3 card-face pokemon-back">
        <h2 className="mb-1">
          Ibtehaz <span className="hp-text">HP: 120 ⚡</span>
        </h2>
        <p className="class-title">Level 7 Code Mage (Full-Stack Developer)</p>

        {this.state.isMobile && (
          <div className="" style={{
            marginBottom: "1rem"
          }}>
            <img
              src="/images/machine_generated_ibtehaz-2.png"
              alt="Ibtehaz"
              className="img-fluid"
            />
          </div>
        )}

        {/* Special Moves */}
        <div className="stat-section">
          <h5 className="section-title">Special Moves</h5>
          <ul className="list-group list-group-flush">
            <li className="list-group-item move-item">
              <strong>Full-Stack Strike (90)</strong> – React, Next.js, Node.js,
              Flask, Electron, Firebase.
            </li>
            <li className="list-group-item move-item">
              <strong>Data Mastery (80)</strong> – Python, SQL, Tableau, Power
              BI.
            </li>
          </ul>
        </div>

        {/* Passive Buffs */}
        <div className="stat-section mt-3">
          <h5 className="section-title">Passive Buffs</h5>
          <ul className="list-group list-group-flush">
            <li className="list-group-item passive-item">
              Tool Shapeshifter – Adapts to new frameworks/APIs fast.
            </li>
            <li className="list-group-item passive-item">
              UX Instinct – Builds smooth, user-friendly experiences.
            </li>
          </ul>
        </div>

        {/* Flavor Text */}
        <p className="flavor-text mt-3">
          "Once you learn the way broadly, you will see it in all things!"
        </p>

        {this.state.isMobile && (
          <div
            className="rotate-icon position-absolute bottom-0 end-0 m-3"
            onClick={this.toggleFlip}
          >
            <FaSyncAlt />
          </div>
        )}
      </div>
    );
  };

  render() {
    const { isMobile, flipped } = this.state;

    return (
      <div
        className={isMobile ? "" : "container my-4"}
        style={{
          paddingTop: "24px",
        }}
      >
        {isMobile ? (
          <div
            className="flip-card"
            style={{
              perspective: "1000px",
              position: "relative",
              height: "100%",
            }}
          >
            <div
              className="flip-card-inner"
              style={{
                transform: flipped ? "rotateY(180deg)" : "rotateY(0deg)",
                transition: "transform 0.6s",
                transformStyle: "preserve-3d",
                position: "relative",
              }}
            >
              <div
                className="flip-card-front"
                style={{
                  backfaceVisibility: "hidden",
                  position: "absolute",
                  width: "100%",
                }}
              >
                {this.renderFront()}
              </div>
              <div
                className="flip-card-back"
                style={{
                  backfaceVisibility: "hidden",
                  transform: "rotateY(180deg)",
                  position: "absolute",
                  width: "100%",
                }}
              >
                {this.renderBack()}
              </div>
            </div>
          </div>
        ) : (
          <div className="row align-items-center">
            <div className="col-md-6">{this.renderFront()}</div>
            <div className="col-md-6">{this.renderBack()}</div>
          </div>
        )}
      </div>
    );
  }
}

export default StatCard;
